import React from "react"
import { api, firestore } from "../../core"
import { useSpaceMessages } from "popopo-lib-front/firestore-access"
import { User } from "firebase/auth"
import { SpaceKey, SpaceMessageId } from "popopo-msg"
import { Button } from "react-bootstrap"

export const SpaceMessageList = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const messages = useSpaceMessages(firestore, props.spaceKey)

  const onDelete = async (id: SpaceMessageId) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/messages/{message_id}", {
        params: { path: { space_key: props.spaceKey, message_id: id } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <div>
        <ul className="list-group w-100">
          {messages === "loading" ? (
            <li>
              <i className="fas fa-spin fa-spinner" />
            </li>
          ) : messages.length === 0 ? (
            <li>メッセージは1つも存在しません。</li>
          ) : (
            messages.map((message) => (
              <li key={message.id} className="list-group-item">
                <>
                  <Button variant="danger btn-sm me-1" onClick={() => onDelete(message.id)}>
                    <span className="fas fa-trash" />
                  </Button>
                  kind: {message.kind} (ID:<code>{message.id}</code>)
                </>
                <div style={{ width: "200px" }}>
                  {message.kind === "image" ? (
                    <img src={message.value} alt={message.id} style={{ width: "100%" }} />
                  ) : message.kind === "video" ? (
                    <video src={message.value} controls={true} style={{ width: "100%" }} />
                  ) : message.kind === "text" || message.kind === "emotion" ? (
                    <>{message.value}</>
                  ) : (
                    <></>
                  )}
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
    </>
  )
}
